<template>
  <div
    class="uni-card"
    :class="{
      'uni-card--full': isFull === true || isFull === 'true',
      'uni-card--shadow': isShadow === true || isShadow === 'true'
    }"
  >
    <!-- 基础 -->
    <div v-if="mode === 'basic' && title" class="uni-card__header" @click.stop="onClick">
      <div v-if="thumbnail" class="uni-card__header-extra-img-view">
        <img :src="thumbnail" class="uni-card__header-extra-img" />
      </div>
      <div class="uni-card__header-title-text">
        <slot name="title">
          <span>{{ title }}</span>
        </slot>
      </div>
      <div :class="['0', '1', '2'].includes(prescriptState) ? 'middle_title' : 'preDetail_state'">
        <span>{{ middleTitle }}</span>
      </div>
      <div v-if="extra">
        <slot name="extra">
          <span class="uni-card__header-extra-text">{{ extra }}</span>
        </slot>
      </div>
      <slot name="close"></slot>
    </div>
    <!-- 标题 -->
    <div v-if="mode === 'title'" class="uni-card__title uni-border-bottom" @click.stop="onClick">
      <div class="uni-card__title-box">
        <div class="uni-card__title-header">
          <img class="uni-card__title-header-image" :src="thumbnail" mode="scaleToFill" />
        </div>
        <div class="uni-card__title-content">
          <span class="uni-card__title-content-title uni-ellipsis">
            {{ title }}
          </span>
          <span class="uni-card__title-content-extra uni-ellipsis">
            {{ subTitle }}
          </span>
        </div>
      </div>
      <div v-if="extra">
        <span class="uni-card__header-extra-text">
          <slot name="extra">{{ extra }}</slot>
        </span>
      </div>
    </div>
    <!-- 图文 -->
    <div v-if="mode === 'style'" class="uni-card__thumbnailimage" @click.stop="onClick">
      <div class="uni-card__thumbnailimage-box">
        <img class="uni-card__thumbnailimage-image" :src="thumbnail" mode="aspectFill" />
      </div>
      <div v-if="title" class="uni-card__thumbnailimage-title">
        <span class="uni-card__thumbnailimage-title-text">{{ title }}</span>
      </div>
    </div>
    <!-- 内容 -->
    <div class="uni-card__content" @click.stop="onClick">
      <div v-if="mode === 'style' && extra" class="">
        <span class="uni-card__content-extra">{{ extra }}</span>
      </div>
      <div @click.stop="onClick">
        <slot></slot>
      </div>
    </div>
    <!-- 底部 -->
    <div v-if="note" class="uni-card__footer">
      <slot name="footer">
        <span class="uni-card__footer-text">{{ note }}</span>
      </slot>
    </div>
  </div>
</template>

<script>
/**
 * Card 卡片
 * @description 卡片视图组件
 * @tutorial https://ext.dcloud.net.cn/plugin?id=22
 * @property {String} title 标题文字
 * @property {String} subTitle 副标题（仅仅mode=title下生效）
 * @property {String} extra 标题额外信息
 * @property {String} note 标题左侧缩略图
 * @property {String} thumbnail 底部信息
 * @property {String} mode = [basic|style|title] 卡片模式
 * 	@value basic 基础卡片
 * 	@value style 图文卡片
 * 	@value title 标题卡片
 * @property {Boolean} isFull = [true | false] 卡片内容是否通栏，为 true 时将去除padding值
 * @property {Boolean} isShadow = [true | false] 卡片内容是否开启阴影
 * @event {Function} click 点击 Card 触发事件
 * @example <uni-card title="标题文字" thumbnail="https://img-cdn-qiniu.dcloud.net.cn/new-page/uni.png" extra="额外信息" note="Tips">内容主体，可自定义内容及样式</uni-card>
 */
export default {
  name: 'UniCard',
  props: {
    title: {
      type: [String, Boolean],
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    extra: {
      type: String,
      default: ''
    },
    note: {
      type: [String, Boolean],
      default: ''
    },
    thumbnail: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'basic'
    },
    isFull: {
      // 内容区域是否通栏
      type: Boolean,
      default: false
    },
    isShadow: {
      // 是否开启阴影
      type: [Boolean, String],
      default: false
    },
    middleTitle: {
      type: String,
      default: ''
    },
    prescriptState: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.uni-card {
  display: flex;
  flex: 1;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  margin: $uni-spacing-col-lg $uni-spacing-row-lg;
  background-color: $uni-bg-color;
  position: relative;
  flex-direction: column;
  // border-radius: 5px;
  overflow: hidden;
  border-radius: 40px 40px 0px 0px !important;
}

.uni-border {
  position: relative;
  z-index: 1;
}

.uni-border:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  border: 1px solid $uni-border-color;
  border-radius: 10px;
  box-sizing: border-box;
  width: 200%;
  height: 200%;
  transform: scale(0.5);
  transform-origin: left top;
  z-index: -1;
}

.uni-border-bottom {
  position: relative;
  z-index: 1;
}

.uni-border-bottom:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  border-bottom: 1px solid $uni-border-color;
  box-sizing: border-box;
  width: 200%;
  height: 200%;
  transform: scale(0.5);
  transform-origin: left top;
  z-index: -1;
}

.uni-border-top {
  position: relative;
  z-index: 1;
}

.uni-border-top:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  border-top: 1px solid $uni-border-color;
  box-sizing: border-box;
  width: 200%;
  height: 200%;
  transform: scale(0.5);
  transform-origin: left top;
  z-index: -1;
}

.uni-card__thumbnailimage {
  position: relative;
  flex-direction: column;
  justify-content: center;
  height: 150px;
  overflow: hidden;
}

.uni-card__thumbnailimage-box {
  display: flex;
  flex: 1;
  flex-direction: row;
  overflow: hidden;
}

.uni-card__thumbnailimage-image {
  flex: 1;
}

.uni-card__thumbnailimage-title {
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  flex-direction: row;
  padding: $uni-spacing-col-base $uni-spacing-col-lg;
  background-color: $uni-bg-color-mask;
}

.uni-card__thumbnailimage-title-text {
  flex: 1;
  font-size: $uni-font-size-base;
  color: #fff;
}

.uni-card__title {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
}

.uni-card__title-box {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
}

.uni-card__title-header {
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 5px;
}

.uni-card__title-header-image {
  width: 40px;
  height: 40px;
}

.uni-card__title-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  padding-left: 10px;
  height: 40px;
  overflow: hidden;
}

.uni-card__title-content-title {
  font-size: $uni-font-size-base;
  line-height: 22px;
}

.uni-card__title-content-extra {
  font-size: $uni-font-size-sm;
  line-height: 27px;
  color: #999;
}

.uni-card__header {
  display: flex;
  border-bottom: 1px solid #ececec;
  position: relative;
  flex-direction: row;
  padding: $uni-spacing-col-lg;
  justify-content: space-between;
  align-items: center;
}

.uni-card__header-title {
  display: flex;
  flex-direction: row;
  margin-right: $uni-spacing-col-base;
  justify-content: flex-start;
  align-items: center;
}

.uni-card__header-title-text {
  width: auto;
  font-size: 36px;
  // flex: 1;
  color: #222;
  font-weight: 500;
}

.middle_title,
.preDetail_state {
  justify-self: center;
  font-size: 36px;
  font-weight: 500;
  line-height: 48px;
  color: #0089ff;
  margin-left: -60px;
}
.preDetail_state {
  color: #ff7555;
}

.uni-card__header-extra-img {
  height: $uni-img-size-sm;
  width: $uni-img-size-sm;
  margin-right: $uni-spacing-col-base;
}

.uni-card__header-extra-text {
  flex: 1;
  margin-left: $uni-spacing-col-base;
  font-size: $uni-font-size-sm;
  text-align: right;
  color: #999;
}

.uni-card__content {
  color: #333;
}

.uni-card__content-extra {
  font-size: $uni-font-size-base;
  padding-bottom: 10px;
  color: #999;
}

.uni-card__footer {
  justify-content: space-between;
  padding: $uni-spacing-col-lg;
}

.uni-card__footer-text {
  color: #999;
  font-size: $uni-font-size-sm;
}

.uni-card--shadow {
  position: relative;
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
}

.uni-card--full {
  margin: 0;
  border-radius: 0;
}

.uni-card--full:after {
  border-radius: 0;
}

.uni-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
